import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import DashboardSidebar from '../components/DashboardSidebar';
import AdminEventManagement from '../components/AdminEventManagement';
import AdminEventPublishPlansManagement from '../components/AdminEventPublishPlansManagement';

const AdminEventsPage = () => {
  const location = useLocation();
  const initialTab =
    location.pathname.includes('publish-plans') || location.search.includes('tab=publish-plans')
      ? 'publish-plans'
      : 'events';

  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8fafc' }}>
      <DashboardSidebar userRole="admin" />
      <div style={{ flex: 1, minHeight: '100vh', padding: '30px 20px', marginLeft: '280px' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
          {/* Main Module Switcher Tabs */}
          <div
            style={{
              display: 'flex',
              gap: '12px',
              padding: '6px',
              background: '#e2e8f0',
              borderRadius: '14px',
              width: 'fit-content',
              marginBottom: '24px',
            }}
          >
            <button
              type="button"
              onClick={() => setActiveTab('events')}
              style={{
                padding: '10px 22px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: 700,
                fontSize: '0.92rem',
                cursor: 'pointer',
                background: activeTab === 'events' ? '#ffffff' : 'transparent',
                color: activeTab === 'events' ? '#7c3aed' : '#64748b',
                boxShadow: activeTab === 'events' ? '0 2px 8px rgba(0,0,0,0.06)' : 'none',
                transition: 'all 0.2s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span>🎉</span> Events & Seminars
            </button>

            <button
              type="button"
              onClick={() => setActiveTab('publish-plans')}
              style={{
                padding: '10px 22px',
                borderRadius: '10px',
                border: 'none',
                fontWeight: 700,
                fontSize: '0.92rem',
                cursor: 'pointer',
                background: activeTab === 'publish-plans' ? '#ffffff' : 'transparent',
                color: activeTab === 'publish-plans' ? '#7c3aed' : '#64748b',
                boxShadow: activeTab === 'publish-plans' ? '0 2px 8px rgba(0,0,0,0.06)' : 'none',
                transition: 'all 0.2s',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span>🗓️</span> Publish Weeks & Pricing Plans
            </button>
          </div>

          {/* Active Tab View */}
          {activeTab === 'events' ? (
            <AdminEventManagement />
          ) : (
            <AdminEventPublishPlansManagement />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminEventsPage;
